<app-modal-base [title]="dialogTitle" (onSubmitEvent)="onSubmit()" [loading]="loading" [isDisabled]="form.invalid"
  [submitText]="'DELETE'">
  <ng-container main *ngTemplateOutlet="content"></ng-container>
</app-modal-base>

<ng-template #content>
  <div mat-dialog-content>
    <div class="alert alert-warning text-center" role="alert">
      La suppression de votre compte est une action irréversible !<br />
      Tous vos biens seront également supprimés.
    </div>
    <div class="formContainer d-flex justify-content-center">
      <form [formGroup]="form" (ngSubmit)="onSubmit()">
        <p class="reason">Pour quelle raison souhaitez-vous supprimer votre compte ?</p>
        <div class="form-group row">
          <app-input [label]="'En quelques mots...'" size="12" [formControl]="form_reason"></app-input>
        </div>
      </form>
    </div>
  </div>
</ng-template>